import { gql, TypedDocumentNode } from "@apollo/client";

import {
  QueryScanArgs,
  ScanRunConnection,
  SearchInput,
  SearchScanRunsOutput,
  SearchSuggestionsInput,
  SearchSuggestionsOutput,
} from "types/generated";

import { ScanRunsListItem } from "./types";

type SearchScanRunsData = {
  scan: {
    searchRuns: {
      edges: Array<Pick<ScanRunConnection, "cursor"> & { node: ScanRunsListItem }>;
      pageInfo: SearchScanRunsOutput["pageInfo"];
    };
  };
};

type SearchScanRunsVariables = QueryScanArgs & {
  input: SearchInput;
};

export const SEARCH_SCAN_RUNS: TypedDocumentNode<SearchScanRunsData, SearchScanRunsVariables> = gql`
  query SearchScanRuns($id: ID!, $input: SearchInput!) {
    scan(id: $id) {
      searchRuns(input: $input) {
        edges {
          cursor
          node {
            id
            createdAt
            duration
            state
            resourceCount
            resourceStats {
              unmanaged
            }
            note
            scan {
              space {
                id
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          endCursor
          startCursor
        }
      }
    }
  }
`;

type SearchScanRunsCountData = {
  scan: {
    searchRunsSuggestions: {
      filteredCount: SearchSuggestionsOutput["filteredCount"];
    };
  };
};

type SearchScanRunsCountVariables = QueryScanArgs & {
  input: SearchSuggestionsInput;
};

export const SEARCH_SCAN_RUNS_COUNT: TypedDocumentNode<
  SearchScanRunsCountData,
  SearchScanRunsCountVariables
> = gql`
  query SearchScanRunsCount($id: ID!, $input: SearchSuggestionsInput!) {
    scan(id: $id) {
      searchRunsSuggestions(input: $input) {
        filteredCount
      }
    }
  }
`;
